<template>
  <v-card>
    <v-card-title>
      <span class="table-card-title d-flex align-center" style="line-height: 1">{{ $t('campanhas.envios') }}</span
      >&nbsp;
      <v-tooltip bottom max-width="192px">
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <mf-icon small color="cinza-0">info</mf-icon>
          </span>
        </template>
        <span>{{ $t('campanhas.envios_tooltip') }}</span>
      </v-tooltip>
      <v-spacer />
      <messages-history
        v-if="showMessageHistory"
        :query="messagesHistoryQuery"
        :campaign-type="campaignType"
        :campaign-id="campaignId"
        :total-sendings="totalSendings"
        :show-cost="showCost"
        :industry="industry"
      />
    </v-card-title>
    <v-data-table :items="sendings" :headers="headers" :loading="loading" hide-default-footer disable-pagination>
      <template v-if="industry" v-slot:header.price="{ header }">
        <v-tooltip bottom max-width="192px">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              {{ header.text }}
              <mf-icon small color="cinza-0">info</mf-icon>
            </span>
          </template>
          <span>Campanha custeada pela indústria</span>
        </v-tooltip>
      </template>

      <template v-slot:item="{ item }">
        <tr>
          <td class="text">{{ item['text'] }}</td>
          <td>{{ DateTime.fromISO(item['date']).toFormat('dd/MM/yyyy') }} | {{ item['time'] }}</td>
          <td>{{ item['sent'] ? 'Efetuado' : 'Agendado' }}</td>
          <td>{{ item['total'] | localeString }}</td>
          <td v-if="showDelivery">{{ item['delivered'] | localeString }}</td>
          <td v-if="showDelivery">{{ getSafe(() => item['delivered'] / item['total']) * 100 || 0 | localeString(2) | percent }}</td>
          <td v-if="showCost">{{ industry ? 0 : item['credits'] | localeString }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { DateTime } from 'luxon'
import { QUERY_GET_MESSAGES_HISTORY } from '@/modules/campanhas/views/components/graphql'

export default {
  components: {
    MessagesHistory: () => import('@/modules/campanhas/views/components/results/MessagesHistory.vue'),
  },
  props: {
    loading: Boolean,
    sendings: Array,
    campaignId: String,
    campaignType: String,
    showDelivery: {
      type: Boolean,
      default: true,
    },
    showCost: {
      type: Boolean,
      default: true,
    },
    industry: null,
  },
  data() {
    return {
      DateTime: DateTime,
    }
  },
  computed: {
    showMessageHistory() {
      const isExternalProvider = this.$getAllowedModules()['external_whatsapp_provider']
      const isWhatsappExternalProvider = this.campaignType === 'whatsapp' && isExternalProvider
      return this.hasPiiAccess && !this.loading && !isWhatsappExternalProvider
    },
    totalSendings() {
      return this.sendings.reduce((acc, { total }) => acc + total, 0)
    },
    messagesHistoryQuery() {
      return QUERY_GET_MESSAGES_HISTORY
    },
    headers() {
      let items = [
        {
          text: this.$t('campanhas.mensagem'),
          value: 'text',
          sortable: false,
          width: '37%',
        },
        {
          text: 'Data de envio',
          value: 'date',
          sortable: false,
          width: '13%',
        },
        {
          text: this.$t('campanhas.status'),
          value: 'sent',
          sortable: false,
          width: '10%',
        },
        {
          text: 'Enviados',
          value: 'total',
          sortable: false,
          width: '10%',
        },
        ...(this.showDelivery
          ? [
              {
                text: 'Recebidos',
                value: 'delivered',
                sortable: false,
                width: '10%',
              },
              {
                text: '% Entrega',
                value: 'delivery_rate',
                sortable: false,
                width: '10%',
              },
            ]
          : []),
      ]
      if (this.showCost) {
        items.push({
          text: this.$t('campanhas.custo'),
          value: 'price',
          sortable: false,
          width: '10%',
        })
      }
      return items
    },
  },
}
</script>
<style lang="scss">
.text {
  text-align: justify;
}
</style>
